import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class TaskService {
    pendSubject = new ReplaySubject();
    signSubject = new ReplaySubject();
    pendLoad = new ReplaySubject<boolean>();
    signLoad = new ReplaySubject<boolean>();
    loadDocs = new ReplaySubject<boolean>();
    pendValue = false;
    loadValue = false;
    constructor() {
        this.pendLoad.next(false);
        this.signLoad.next(false);
        this.loadDocs.next(false);
     }

    getPend() {
        return this.pendSubject;
    }

    setPend(data: any) {
        this.pendSubject.next(data);
    }

    getSign() {
        return this.signSubject;
    }

    setSign(data: any) {
        this.signSubject.next(data);
    }

    setPendLoad(value: boolean) {
        this.pendLoad.next(value);
    }

    getPendLoad() {
        return this.pendLoad;
    }

    setSignLoad(value: boolean) {
        this.signLoad.next(value);
    }

    getSignLoad() {
        return this.signLoad;
    }


    getLoadDocs() {
        
        this.pendLoad.subscribe((pendValue: boolean) => {
            this.pendValue = pendValue;
            if(this.pendValue && this.loadValue) {
                this.loadDocs.next(true);
            }
        });
        this.signLoad.subscribe((loadValue: boolean) => {
            this.loadValue = loadValue;
            if(this.pendValue && this.loadValue) {
                this.loadDocs.next(true);
            }
        });
        
        return this.loadDocs;
    }
}